module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/Logo_SCT_Outil_Libre_small.ef2bffc7.png";